import React, { Component } from 'react';
import { Link } from "react-router-dom"
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import './navbar.css';
import { Icon } from 'react-icons-kit';
import { user } from 'react-icons-kit/fa/user';
import firebase from 'firebase/app';

export default class Navegacion extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this)

    this.state = {
      isOpen: false,
      user: null
    }
    this.logOut = this.logOut.bind(this)
    this.LinkClick = this.LinkClick.bind(this)
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  LinkClick() {
    this.state.isOpen && this.toggle()
  }

  logOut() {
    this.LinkClick()
    firebase.auth().signOut()
      .then()
      .catch()
  }

  componentDidMount() {
    const _this = this
    firebase.auth().onAuthStateChanged(function (user) {
      if(!user){
        window.location.replace("/")
      }
      _this.setState({ user })
    })
  }

  render() {
    return (
      <div>
        <Navbar color="warning" className="navbar fixed-top text-uppercase" expand="md">
          <NavbarBrand></NavbarBrand>
          <NavbarToggler className="navbar-dark" onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar className="justify-content-between">
            <Nav navbar className="navbar-nav-admin">
              <NavItem>
                <Link onClick={this.LinkClick} className="nav-link" to="/admin/empresa">Empresa</Link>
              </NavItem>
              <NavItem >
                <Link onClick={this.LinkClick} className="nav-link" to="/admin/productos">Productos</Link>
              </NavItem>
              <NavItem>
                <Link onClick={this.LinkClick} className="nav-link" to="/admin/descargas">Descargas</Link>
              </NavItem>
              <NavItem>
                <Link onClick={this.LinkClick} className="nav-link" to="/admin/usuarios">Usuarios</Link>
              </NavItem>
              <NavItem>
                <Link onClick={this.LinkClick} className="nav-link" to="/admin/analytics">Analytics</Link>
              </NavItem>
            </Nav>
            <Nav className="ml-5 navbar-nav-admin" navbar>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  <Icon size={20} icon={user} className="warning" />
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem>
                    {this.state.user && this.state.user.email}
                  </DropdownItem>
                  <DropdownItem onClick={ ()=>{window.location.href = '/'}}>
                    <Link className="dropdownItem" to="/">Principal</Link>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={this.logOut}>
                    <Link className="dropdownItem" to="/">Salir</Link>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    )
  }
}